import React, { useRef, useEffect, MouseEvent } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useBreadcrumbsSizeChange } from './Breadcrumb.hooks';
import { SocialBar } from './components/SocialBar';
import { BreadcrumbItem, Breadcrumb as BreadcrumbType } from '../../HeaderBar.types';
import './Breadcrumb.scss';
import { useFetchContactUsFormQuery } from '@pages/ContactUs/ContactUs.service';

interface BreadcrumbProps {
  breadcrumb: BreadcrumbType;
}

export const Breadcrumb = ({ breadcrumb }: BreadcrumbProps) => {
  const breadcrumbRef = useRef(null);
  const { data: contactUsForm } = useFetchContactUsFormQuery();
  useBreadcrumbsSizeChange(breadcrumbRef);

  return (
    <div ref={breadcrumbRef} className='c-breadcrumb'>
      <div className='c-breadcrumb-container'>
        {breadcrumb &&
          breadcrumb.Breadcrumbs.map(
            (item, index) => {
              const lastBreadcrumbItem = index === breadcrumb.Breadcrumbs.length - 1;

              return (
                item.Href && (
                  <span
                    key={index}
                    className={
                      index > 0 ? 'c-breadcrumb-links c-breadcrumb-separator' : 'c-breadcrumb-links'
                    }
                  >
                    <a
                      // Story 469071: Breadcrumb changes as per ARC - disabled last breadcrumb item with css 
                      className={`c-breadcrumb-link ${lastBreadcrumbItem ? 'c-breadcrumb-disabled-link' : ''}`}
                      key={index}
                      href={lastBreadcrumbItem ? undefined : item.Href}
                      dangerouslySetInnerHTML={{
                        __html: item.Text,
                      }}
                      // Story 469071: Breadcrumb changes as per ARC - added aria-current property to the last breadcrumb item
                      aria-current={lastBreadcrumbItem ? 'page' : undefined}
                    />
                  </span>
                )
              );
            })}
      </div>
      {breadcrumb && contactUsForm ? (
        <SocialBar
          shareTitle={breadcrumb?.Share || ''}
          hideRequestQuote={contactUsForm?.hideRequestQuote}
          contactUsForm={contactUsForm}
        />
      ) : (
        // used to render loading indicator
        <div className='c-headerbar-social' />
      )}
    </div>
  );
};

export default Breadcrumb;
